module.exports = __webpack_public_path__ + "img/15.b9b8556a.jpg";